
 const baseURL = "https://bridgeviewships.ae"; // production
  // const baseURL = "http://localhost:8000"; // Development


export default baseURL;